<div class="app-popup">
  <div class="app-popup-content text-center">
    <div class="mb-4">
      <h4 *ngIf="!data">
        {{ "delete_product_cart.areYouSureWantDeleteProduct" | translate }}
      </h4>
      <h4 *ngIf="data">{{ data }}</h4>
    </div>
    <button
      mat-raised-button
      color="accent"
      class="mr-3 color-primary"
      (click)="dialogRef.close('yes')"
    >
      {{ "cancel_order.yes" | translate }}
    </button>
    <button
      mat-raised-button
      color="accent"
      class="mr-3 color-secondary"
      (click)="dialogRef.close()"
    >
      {{ "cancel_order.no" | translate }}
    </button>
  </div>
</div>
